// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const MyAccount: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61 61"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M30.5 1.1C14.3 1.1 1.1 14.3 1.1 30.5s13.2 29.4 29.4 29.4 29.4-13.2 29.4-29.4S46.7 1.1 30.5 1.1zm0 2.8c14.7 0 26.6 11.9 26.6 26.6 0 6.3-2.2 12.2-6 16.8l-.5-2.7c-1.4-5.3-6.8-6.4-9.8-7.1-.5-.1-1.1-.2-1.3-.3-1.6-.7-2.6-1.7-3.1-3 1.8-1.7 3.3-4.1 4.2-6.8 1-1.4 1.6-2.7 1.6-4 0-.8-.2-1.6-.7-2.1-.4-6.4-5.1-11.4-10.8-11.5h-.2c-5.6 0-10.3 4.9-10.9 11.1-.7.6-1.1 1.5-1.1 2.5 0 1.5.7 3.1 2.1 4.7.9 2.3 2.1 4.3 3.7 5.8-.5 1.3-1.5 2.3-3.1 3-.2.1-.7.2-1.2.3-2.7.6-8.4 2-9.8 7.4L9.6 47C6 42.5 3.9 36.7 3.9 30.5c0-14.7 11.9-26.6 26.6-26.6zM11.9 49.6l.9-4.3c1-3.7 5.3-4.7 7.8-5.3.7-.2 1.3-.3 1.7-.5 3.4-1.5 4.6-3.9 4.9-5.7l.1-.8-.6-.5c-1.5-1.3-2.8-3.3-3.6-5.5l-.1-.3-.2-.2c-1-1.1-1.6-2.2-1.6-3 0-.3.1-.5.3-.6l.6-.4v-.7c.2-5.1 3.8-9.1 8.2-9.1h.1c4.4.1 8 4.2 8.1 9.3v.6l.5.4c.1.1.2.2.2.5 0 .7-.4 1.6-1.1 2.5l-.2.2-.1.2c-.8 2.6-2.3 4.9-4 6.3l-.6.5.2.8c.3 1.8 1.5 4.2 4.9 5.7.4.2 1 .3 1.8.5 2.5.5 6.7 1.5 7.7 5l.9 4.6c-4.8 4.6-11.2 7.4-18.4 7.4-7-.1-13.6-3-18.4-7.6z"/></svg>;
};

export default React.memo(MyAccount);
